module.exports={
    products: {
    	commodityManage:'商品管理',
    	search:'搜索',
    	import:'导 入',
        download:'下 载',
    	add:'新 增',
		delete:'删 除',
		submiting: '提交中...',
    	table1:{	//商品管理表格
            barcode:'条形码',
    		index:'序号',
            name:'商品名称',
    		brand:'品牌',
    		specification:'规格',
            price:'价格',
    		status:'状态',
            statusUnbound:'未绑定',
			statusBind:'已绑定',
			statusUnbound1:'未绑定',
            statusBind1:'已绑定',
    		operation:'操作',
    		delete:'删除'
    	},
    	commodityDetails:'商品详情',
    	form1:{		//商品详情表单
    		proNo:'商品编号：',
    		name:'商品名称：',
    		proAbbr:'商品简称：',
    		price:'价格：',
    		brand:'品牌：',
    		specification:'规格：',
    		rating:'等级：',
    		piece:'单位：',
    		origin:'产地：',
            supplierName:'供货商：',
    		barcode:'条形码：',
    		qrcode:'二维码：',
    		save:'保 存',
            hint:'请选择商品！',
            success:'修改商品成功，更新标签指令发送成功，请稍后刷新页面获取最新数据！',
            fail:'修改商品失败！',
            fail0:'修改商品成功，更新标签失败！',
            fail1:'修改商品失败，标签没有与网关绑定！',
            fail2:'修改商品失败，没有导入对应的标签！',
            fail3:'修改商品失败，绑定的标签中存在空模板！',
            fail4:'修改商品成功，更新标签失败，商品没有绑定标签！',
            fail5:'修改商品成功，更新标签失败，标签绑定的模板不存在！',
            noPermission:'修改商品失败，没有权限！',
            label:'标签 ',
            length:'长度为{num}个字符以内',
            barcodeLen:'长度为13位数字',
            unfold:'展开',
            fold:'收起'
    	},
    	preview:'显示预览',
    	bindTag:'绑定标签',
    	table2:{     //绑定标签表格
    		mac:'Mac地址',
    		demoName:'模板',
    		status:'状态',
            statusSucceeded:'更新成功',
            // statusSucceeded1:'更新成功',
            statusFailed:'更新失败',
            // statusFailed1:'更新失败',
    		operation:'操作',
    		delete:'删除',
    		push:'重推',
    		update:'修改',
    	},
    	dialogAdd:{   //商品管理-新增弹框
    		dialogTitle:'新 增',
    		proNo:'商品编号',
    		name:'商品名称',
    		proAbbr:'商品简称',
    		price:'价格',
    		brand:'品牌',
    		specification:'规格',
    		rating:'等级',
    		piece:'单位',
    		origin:'产地',
    		barcode:'条形码',
    		qrcode:'二维码',
            supplierName:'供货商',
    		cancel:'取 消',
    		sure:'确 定',
            addProSuccess:'新增商品成功！',
            addProFail:'新增商品失败！',
            noPermission:'新增商品失败，没有权限！',
            alreadyExists:'商品已添加！'

        },
        dialogExport:{
            more:"更多",
            allExport:"全部导出",
            partExport:"导出",
            dialogTitle:"导出",
            dialogMsgAll:"确定导出所有的商品吗?",
            dialogMsgPart:"确定导出选中的商品吗?",
            hint:"请先选择要导出的商品！",
            errorMsg:"商品导出失败！"
        },
        dialogRgb:{
            rgbSet:"RGB灯设置",
            timeRgb:"RGB灯亮灯时间：",
            colorRgb:"RGB灯亮灯颜色：",
            setIlluminate:"RGB灯亮度设置：",
            selectTime:"请选择时间",
            openRgb:"亮灯",
            shutRgb:"关灯",
            Red:"红",
            Gre:"绿",
            Blu:"蓝",
            hint:"请勾选需要操作的商品！",
            successHit:'RGB灯设置成功',
            noBind:"没有绑定网关"   ,
            noLable:"没有此标签",
            getawayoffLine:"网关离线",
            warHit:"RGB灯设置失败",
            cardNoLable:"该商品未绑定，请先绑定标签",
            checkTime:"太长的亮灯时间将加速电池损耗",
            label:'标签 ',
            successOpenAll:'全部标签亮灯指令发送成功',
            errorOpenAll:'全部标签亮灯指令发送失败',
            successOpenPart:'部分标签亮灯指令发送成功',
            successShutAll:"全部标签关灯指令发送成功",    
            successShutPart:"部分标签关灯指令发送成功",  
            errorShutAll:"全部标签关灯指令发送失败"  ,
            failList:"失败列表"
        },
    	dialogDelAll:{ //商品管理-删除选中全部弹框
    		dialogTitle:'删 除',
    		dialogMsg:'确定删除选中的商品吗?',
            hint:'请先选择要删除的商品！',
            deleteSuccess:'批量删除商品成功！',
            deleteFail:'批量删除商品失败！',
            noPermission:'批量删除商品失败，没有权限！'
    	},
    	dialogDel1:{ //商品管理-删除弹框
    		dialogTitle:'删 除',
    		dialogMsg:'确定删除ID为{id}的商品吗?',
            success:'删除商品成功！',
            fail:'删除商品失败！',
            noPermission:'删除商品失败，没有权限！'
    	},
    	dialogSave:{ //商品详情-保存弹框
    		dialogTitle:'保 存',
    		dialogMsg:'确定保存吗?',
    	},
    	dialogDel2:{ //绑定标签-删除弹框
    		dialogTitle:'删 除',
    		dialogMsg:'确定删除{mac}吗?',
    	},
    	dialogPush:{ //绑定标签-重推弹框
    		dialogTitle:'重 推',
    		dialogMsg:'确定重推{mac}吗?',
            updateSuccess:'更新成功',
            updateFail:'更新失败',
            hint:'标签并未进行初次推送，请操作推送功能！',
            successMsg1:'当前标签设备已更新成功，无须重推！',
            pushSuccess:'重推成功！',
            pushFail:'重推失败！',
            updateSuccess2:'设备已经更新成功，请刷新页面获取最新数据！',
            noTemplate:'模板不存在',
            noGateway:'绑定的网关不是此门店的网关',
            noBind:'标签未绑定网关'

    	},
    	dialogUpdate:{ //绑定标签-修改弹框
    		dialogTitle:'修 改',
    		mac:'Mac地址',
    		demoName:'模板',
            chooseTemplate:'请选择模板',
    		cancel:'取 消',
    		sure:'确 定',
            getTemplateFail:'获取该尺寸所有模板失败！请重新操作',
            success:'修改标签绑定的模板成功！',
            fail:'修改标签绑定的模板失败！',
			bindGateway:'请先将该设备绑定网关！',
			tip:'当前标签未绑定过网关，请先绑定网关后再操作此功能',
            noTemplate:'模板不存在',
            noGateway:'绑定的网关不是此门店的网关',
            problemTemplate:'该标签绑定的模板有误，请重新绑定正确的模板',
            noTemplates:'不存在对应匹配的模板，请添加对应类型的模板'

    	},
        queryLabel:{ //绑定标签-查询标签
            fail:'查询与商品绑定的标签失败！',
            msg:'该商品未绑定标签'
        },
        queryProduct:{ //查询商品
            fail:'查询商品失败！'
        },
        getPrefix:{ //获取标签前缀
            fail:'获取标签前缀失败'
        },
        unbind:{
            success:'解除商品和标签的绑定成功！',
            fail:'解除商品和标签的绑定失败！'
        },
        labelLight:{   //标签灯
            green1:'/static/images/label_green_1.png',
            green2:'/static/images/label_green_2.png',
            blue1:'/static/images/label_blue_1.png',
            blue2:'/static/images/label_blue_2.png',
            red1:'/static/images/label_red_1.png',
            red2:'/static/images/label_red_2.png'
        },
        labelLightMsg:{   //标签灯提示信息
            green:'亮绿灯',
            red:'亮红灯',
            blue:'亮蓝灯',
            success:'标签 {mac}：亮{color}灯指令发送成功',
            fail:'标签 {mac}：亮{color}灯指令发送失败',
            unbind:'标签 {mac}：当前标签未绑定网关',
            noLabel:'标签 {mac}：当前标签不存在',
            chooseLabel:'请选择要亮灯的标签',
            color:[{
                key:'1',
                value:'蓝'
            },{
                key:'2',
                value:'绿'
            },{
                key:'3',
                value:'红'
            }]
        },
        cancel:'取 消',
        sure:'确 定',
        hint:'提 示',
        checkout:{
            formatAndDecimals1:'请输入正确格式',
            formatAndDecimals2:'最多有两位小数',
            id:'请输入ID',
            length:'请输入13位数字',
            productAdd:'商品已添加',
            fail:'获取失败,请重新输入',
            proNo:'请输入字母或数字'
        },
        upload:{
            format:'上传文件只能是Excel表格',
            success:'导入商品成功，成功{success}个！',
            fail:'导入商品失败！',
            incorrectFormat:'文件格式不正确！',
            parseFail:'文件解析失败！',
            noPermission:'导入商品失败，没有权限！'
        },
        permission:{  //数据库数据，判断权限，不可改动
            addPro:'新增商品',
            delPro:'删除商品',
            updatePro:'修改商品'
        },
        timeSet:[{lab:'1分钟',val:'60'},{lab:'30分钟',val:'1800'},{lab:'1小时',val:'3600'},{lab:'2小时',val:'7200'},{lab:'4小时',val:'14400'},{lab:'8小时',val:'28800'},{lab:'12小时',val:'43200'}],
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/products.js